attachEvent('.mod-filter__trigger', 'click', (e) => {
  const parentElem = e.target.closest('.mod-filter');
  parentElem.classList.add('is-open-filter');
  toggleBodyScrollLock(true);
});

attachEvent('.mod-filter__close', 'click', (e) => {
  const parentElem = e.target.closest('.mod-filter');
  parentElem.classList.remove('is-open-filter');
  toggleBodyScrollLock(false);
});

onKeydown('escape', () => {
  const filterEle = document.querySelectorAll('.mod-filter.is-open-filter');
  filterEle.forEach((el) => {
    el.classList.remove('is-open-filter');
    toggleBodyScrollLock(false);
  });
});
